<template>
<div class="chapter">
<div class="inner_page">
<p class="p6">By M.A. C<span class="t9">HURCH</span></p>
<p class="p0">Trouble Comes in Threes</p>
<p class="p7">Wrapped in Leather</p>
<p class="p0"><span class="t10">T</span><span class="t11">HE</span> <span class="t10">G</span><span class="t11">ODS</span></p>
<p class="p0">Priceless</p>
<p class="p0">Perfect</p>
<p class="p7">Pure</p>
<p class="p0"><span class="t12">L</span><span class="t13">EAP</span> <span class="t13">OF</span> <span class="t12">F</span><span class="t13">AITH</span></p>
<p class="p0">Shadows in the Night</p>
<p class="p7">To Touch the Sky</p>
<p class="p0"><span class="t14">With Julie Lynn Hayes</span></p>
<p class="p0"><span class="t10">M</span><span class="t11">OONLIT</span> <span class="t10">S</span><span class="t11">KIES</span></p>
<p class="p0">Be My Alien</p>
<p class="p0">Be My Human</p>
<p class="p8">Published by D<span class="t9">REAMSPINNER</span> P<span class="t9">RESS</span></p>
<p class="p0">http://www.dreamspinnerpress.com</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?32f91811